window.openDeliveryLocationDrawer = function () {
  const drawer = document.getElementById("DeliveryLocationDrawer");
  if (drawer) {
    drawer.open();
  }
};

if (!customElements.get("delivery-location-drawer")) {
  customElements.define(
    "delivery-location-drawer",
    class DeliveryLocationDrawer extends HTMLElement {
      constructor() {
        super();
        this.drawerBody = this.querySelector(".drawer__body");
        this.drawerInner = this.querySelector(".drawer__inner");
        this.closeButtons = this.querySelectorAll(
          ".drawer__close-btn, .fixed-overlay"
        );
        this.doneButton = this.querySelector("#doneButton");
        this.changeLocationLinks = this.querySelectorAll(
          '[data-action="change-delivery-location"]'
        );
        this.useCurrentLocationBtn = this.querySelector(
          ".use-current-location-btn"
        );

        this.bindEvents();
      }

      bindEvents() {
        this.closeButtons.forEach((button) => {
          button.addEventListener("click", this.close.bind(this));
        });

        if (this.doneButton) {
          this.doneButton.addEventListener(
            "click",
            this.handleDoneButton.bind(this)
          );
        }

        this.changeLocationLinks.forEach((link) => {
          link.addEventListener("click", this.handleChangeLocation.bind(this));
        });

        if (this.useCurrentLocationBtn) {
          this.useCurrentLocationBtn.addEventListener(
            "click",
            this.handleCurrentLocation.bind(this)
          );
        }

        document.addEventListener("keydown", (event) => {
          if (event.key === "Escape" && this.hasAttribute("active")) {
            this.close();
          }
        });
      }

      open() {
        this.removeAttribute("hidden");
        this.setAttribute("open", "");
        this.drawerInner.getBoundingClientRect();
        this.drawerInner.getBoundingClientRect();

        requestAnimationFrame(() => {
          this.setAttribute("active", "");
          document.body.classList.add("overflow-hidden");
          this.dispatchOpenEvent();
          this.updateDeliveryView();
        });
      }

      close() {
        this.removeAttribute("active");

        const handleTransitionEnd = (event) => {
          if (
            event.propertyName === "transform" &&
            event.target === this.drawerInner
          ) {
            this.removeAttribute("open");
            this.setAttribute("hidden", "");
            document.body.classList.remove("overflow-hidden");
            this.drawerInner.removeEventListener(
              "transitionend",
              handleTransitionEnd
            );
            // Dispatch delivery:closed event after transition completes
            this.dispatchCloseEvent();
          }
        };

        this.drawerInner.addEventListener("transitionend", handleTransitionEnd);
      }

      dispatchOpenEvent() {
        document.dispatchEvent(new CustomEvent("delivery:opened"));
      }

      dispatchCloseEvent() {
        document.dispatchEvent(new CustomEvent("delivery:closed"));
      }

      updateDeliveryView() {
        const deliveryAddress = localStorage.getItem("deliveryAddress");
        const addressInputContainer = document.getElementById(
          "addressInputContainer"
        );
        const deliveryAddressDisplay = document.getElementById(
          "deliveryAddressDisplay"
        );

        if (
          deliveryAddress &&
          addressInputContainer &&
          deliveryAddressDisplay
        ) {
          const addressData = JSON.parse(deliveryAddress);
          const locationText = document.getElementById("deliveryLocationText");
          if (locationText) {
            locationText.textContent = addressData.location;
          }
          addressInputContainer.style.display = "none";
          deliveryAddressDisplay.style.display = "flex";
        } else if (addressInputContainer && deliveryAddressDisplay) {
          addressInputContainer.style.display = "flex";
          deliveryAddressDisplay.style.display = "none";
        }
      }

      async handleDoneButton() {
        const addressInputContainer = document.getElementById(
          "addressInputContainer"
        );

        if (
          addressInputContainer &&
          addressInputContainer.style.display !== "none"
        ) {
          if (this.validateAndSaveAddress()) {
            const deliveryAddress = localStorage.getItem("deliveryAddress");
            if (deliveryAddress) {
              const addressData = JSON.parse(deliveryAddress);

              // Check if shipping is available for this location
              try {
                const validation = await this.validateShippingAvailability(
                  addressData
                );
                if (!validation.hasShipping) {
                  alert(
                    "Delivery is not available for this location. Please try another address or contact us for assistance."
                  );
                  // Don't close drawer, let user try again
                  return;
                }
              } catch (error) {
                console.warn(
                  "Could not validate shipping availability:",
                  error
                );
                // Continue anyway if validation fails
              }

              const locationText = document.getElementById(
                "deliveryLocationText"
              );
              if (locationText) {
                locationText.textContent = addressData.location;
              }

              const deliveryAddressDisplay = document.getElementById(
                "deliveryAddressDisplay"
              );
              if (addressInputContainer && deliveryAddressDisplay) {
                addressInputContainer.style.display = "none";
                deliveryAddressDisplay.style.display = "flex";
              }
            }
          } else {
            return;
          }
        }

        this.close();

        document.dispatchEvent(new CustomEvent("delivery_location_updated"));
      }

      validateAndSaveAddress() {
        const state = document.getElementById("state").value;
        const postalCode = document.getElementById("postalCode").value;

        if (!state) {
          alert("Please select a state");
          return false;
        }

        if (!postalCode || !/^\d{4}$/.test(postalCode)) {
          alert("Please enter a valid 4-digit Australian postal code");
          return false;
        }

        // Basic validation for Australian postcodes
        const code = parseInt(postalCode);

        // Validate postcode ranges for each state
        const postalCodeRanges = {
          NSW: [1000, 2999],
          ACT: [2600, 2618, 2900, 2920],
          VIC: [3000, 3999],
          QLD: [4000, 4999],
          SA: [5000, 5999],
          WA: [6000, 6999],
          TAS: [7000, 7999],
          NT: [800, 999],
        };

        // Exclude special postcodes that don't belong to their state ranges
        const excludedPostcodes = {
          NSW: [2899, 2999], // Norfolk Island postcodes
        };

        // Check if postcode is in excluded list first
        if (
          excludedPostcodes[state] &&
          excludedPostcodes[state].includes(code)
        ) {
          alert(
            "This postal code does not belong to the selected state. Please check your address or select the correct state."
          );
          return false;
        }

        let isValidPostalCode = false;
        if (state === "ACT") {
          isValidPostalCode =
            (code >= 2600 && code <= 2618) || (code >= 2900 && code <= 2920);
        } else {
          const range = postalCodeRanges[state];
          isValidPostalCode = code >= range[0] && code <= range[1];
        }

        if (!isValidPostalCode) {
          alert(
            "The postal code you entered does not match the selected state"
          );
          return false;
        }

        const stateElement = document.getElementById("state");
        const stateName = stateElement.options[stateElement.selectedIndex].text;

        const addressData = {
          state: state,
          postalCode: postalCode,
          location: stateName + " " + postalCode,
        };

        localStorage.setItem("deliveryAddress", JSON.stringify(addressData));
        return true;
      }

      async validateShippingAvailability(addressData) {
        return new Promise(async (resolve) => {
          try {
            // Fetch cart data to get price and weight
            const cartResponse = await fetch("/cart.js");
            const cart = await cartResponse.json();

            if (!cart) {
              resolve({ valid: false, hasShipping: false });
              return;
            }

            // Get cart total price in cents
            const cartPrice = cart.total_price || 0;

            // Calculate total weight in grams
            let totalGrams = 0;
            if (cart.items && cart.items.length > 0) {
              totalGrams = cart.items.reduce((total, item) => {
                const itemWeight = (item.grams || 0) * (item.quantity || 1);
                return total + itemWeight;
              }, 0);
            }

            // Build query parameters for Postcode Shipping app endpoint
            const params = new URLSearchParams({
              country: "AU",
              postal_code: addressData.postalCode,
              price: cartPrice.toString(),
              grams: totalGrams.toString(),
            });

            // Add state if available
            if (addressData.state) {
              params.append("state", addressData.state);
            }

            // Call Postcode Shipping app API
            const response = await fetch(
              `/apps/postcode-shipping/quote?${params.toString()}`,
              {
                method: "GET",
                headers: { "Content-Type": "application/json" },
              }
            );

            if (!response.ok) {
              resolve({ valid: false, hasShipping: false });
              return;
            }

            const data = await response.json();

            // Check if we have shipping rates
            let shippingRates = [];
            if (Array.isArray(data)) {
              shippingRates = data;
            } else if (data?.rates && Array.isArray(data.rates)) {
              shippingRates = data.rates;
            } else if (
              data?.shipping_rates &&
              Array.isArray(data.shipping_rates)
            ) {
              shippingRates = data.shipping_rates;
            }

            if (shippingRates.length > 0) {
              resolve({ valid: true, hasShipping: true });
            } else {
              resolve({ valid: true, hasShipping: false });
            }
          } catch (error) {
            console.warn("Error validating shipping availability:", error);
            resolve({ valid: false, hasShipping: false });
          }
        });
      }

      handleChangeLocation(e) {
        e.preventDefault();
        const addressInputContainer = document.getElementById(
          "addressInputContainer"
        );
        const deliveryAddressDisplay = document.getElementById(
          "deliveryAddressDisplay"
        );

        if (addressInputContainer && deliveryAddressDisplay) {
          addressInputContainer.style.display = "flex";
          deliveryAddressDisplay.style.display = "none";
        }
      }

      handleCurrentLocation() {
        if (!navigator.geolocation) {
          alert(
            "Geolocation is not supported by your browser. Please enter your address manually."
          );
          return;
        }

        const button = this.useCurrentLocationBtn;
        const originalText = button.querySelector(".btn__text").textContent;
        button.querySelector(".btn__text").textContent = "Getting location...";
        button.disabled = true;

        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.reverseGeocode(
              position.coords.latitude,
              position.coords.longitude,
              button,
              originalText
            );
          },
          (error) => {
            let errorMessage = "Unable to get your location. ";

            switch (error.code) {
              case error.PERMISSION_DENIED:
                errorMessage += "Please allow location access and try again.";
                break;
              case error.POSITION_UNAVAILABLE:
                errorMessage += "Location information is unavailable.";
                break;
              case error.TIMEOUT:
                errorMessage += "Location request timed out.";
                break;
              default:
                errorMessage += "An unknown error occurred.";
                break;
            }

            alert(errorMessage + " Please enter your address manually.");
            button.querySelector(".btn__text").textContent = originalText;
            button.disabled = false;
          },
          {
            maximumAge: 60000,
            timeout: 10000,
            enableHighAccuracy: true,
          }
        );
      }

      async reverseGeocode(latitude, longitude, button, originalText) {
        try {
          // Use a free geocoding service to get address from coordinates
          const response = await fetch(
            `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
          );

          if (!response.ok) {
            throw new Error(
              `Geocoding service returned ${response.status}: ${response.statusText}`
            );
          }

          const data = await response.json();

          // Check if the user is in Australia
          if (data.countryCode !== "AU") {
            alert(
              `Sorry, this store only delivers within Australia. Your current location appears to be in ${data.countryName}. Please note that our delivery services are limited to Australian addresses only.`
            );
            button.querySelector(".btn__text").textContent = originalText;
            button.disabled = false;
            return;
          }

          // Extract Australian state and postal code
          const state = this.getAustralianStateCode(data.principalSubdivision);
          const postalCode = data.postcode;

          if (!state || !postalCode) {
            alert(
              "Unable to determine your exact location. Please enter your address manually."
            );
            button.querySelector(".btn__text").textContent = originalText;
            button.disabled = false;
            return;
          }

          // Validate postal code format
          if (!/^\d{4}$/.test(postalCode)) {
            alert(
              "Invalid postal code detected. Please enter your address manually."
            );
            button.querySelector(".btn__text").textContent = originalText;
            button.disabled = false;
            return;
          }

          // Fill in the form
          const stateElement = document.getElementById("state");
          const postalCodeElement = document.getElementById("postalCode");

          if (stateElement && postalCodeElement) {
            stateElement.value = state;
            postalCodeElement.value = postalCode;

            // Trigger change events to ensure any listeners are notified
            stateElement.dispatchEvent(new Event("change"));
            postalCodeElement.dispatchEvent(new Event("input"));

            const locality = data.locality || data.city || "your area";
            alert(
              `Location detected: ${data.principalSubdivision} ${postalCode} (${locality})`
            );
          } else {
            alert(
              "Unable to fill in the form. Please enter your address manually."
            );
          }
        } catch (error) {
          // Provide more specific error messages
          let errorMessage = "Unable to determine your location. ";
          if (error.message.includes("Failed to fetch")) {
            errorMessage += "Network connection issue detected. ";
          } else if (error.message.includes("500")) {
            errorMessage += "Geocoding service is temporarily unavailable. ";
          }
          errorMessage += "Please enter your address manually.";

          alert(errorMessage);
        } finally {
          // Reset button
          button.querySelector(".btn__text").textContent = originalText;
          button.disabled = false;
        }
      }

      getAustralianStateCode(stateName) {
        const stateMapping = {
          "New South Wales": "NSW",
          Victoria: "VIC",
          Queensland: "QLD",
          "Western Australia": "WA",
          "South Australia": "SA",
          Tasmania: "TAS",
          "Australian Capital Territory": "ACT",
          "Northern Territory": "NT",
        };

        // Try exact match first
        if (stateMapping[stateName]) {
          return stateMapping[stateName];
        }

        // Try partial match
        for (const [fullName, code] of Object.entries(stateMapping)) {
          if (stateName.includes(fullName) || fullName.includes(stateName)) {
            return code;
          }
        }

        return null;
      }
    }
  );
}

document.addEventListener("DOMContentLoaded", function () {
  updateLocationDisplaysOnPage();

  document
    .querySelectorAll('[data-action="open-delivery-location"]')
    .forEach((link) => {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        if (typeof window.openDeliveryLocationDrawer === "function") {
          window.openDeliveryLocationDrawer();
        } else {
          console.error("openDeliveryLocationDrawer function not available");
        }
      });
    });
});

document.addEventListener("delivery_location_updated", function () {
  updateLocationDisplaysOnPage();
});

function updateLocationDisplaysOnPage() {
  const locationDisplays = document.querySelectorAll(
    '[data-display="delivery-location"]'
  );
  const deliveryAddress = localStorage.getItem("deliveryAddress");

  if (deliveryAddress && locationDisplays.length > 0) {
    const addressData = JSON.parse(deliveryAddress);
    locationDisplays.forEach((display) => {
      display.textContent = addressData.location;
    });
  }
}
